module.exports = __webpack_public_path__ + "static/media/thermostat.d1ee6259.png";